module.exports = __webpack_public_path__ + "bm.55b93e100610638ee99d.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/bm.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/bm.svg
// module chunks = styles